import { useEffect, useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';

/**
 * ✨ Einmaliger Hinweis „Neu in PaketPilot" nach einem größeren Update.
 *
 * Für Bestandsnutzer: es bleibt alles, wie es ist — der Hinweis zeigt nur, dass es mehr gibt
 * (Setup, Hilfe). Erscheint pro Gerät genau einmal je Ausgabe (STAND), frühestens ein paar
 * Sekunden nach dem Start und nur, wenn `aktiv` (angemeldet, Pakete vorhanden, kein Mitarbeiter-Modus).
 * Neue Konten ohne Pakete sehen ihn nicht — für sie ist nichts „neu".
 */
const KEY = 'kiosk_whatsnew_seen';
export const WHATSNEW_STAND = '2026-10-setup';

export function whatsNewOffen() {
  try { return localStorage.getItem(KEY) !== WHATSNEW_STAND; } catch { return false; }
}
function merken() {
  try { localStorage.setItem(KEY, WHATSNEW_STAND); } catch { /* */ }
}

export default function WhatsNewHint({ aktiv, colors, onOpenSetup, onOpenHelp }) {
  const { t } = useTranslation();
  const [offen, setOffen] = useState(false);
  const dark = colors?.darkMode;

  useEffect(() => {
    if (!aktiv || !whatsNewOffen()) return undefined;
    const timer = setTimeout(() => { if (whatsNewOffen()) setOffen(true); }, 2500);
    return () => clearTimeout(timer);
  }, [aktiv]);

  if (!offen) return null;
  const zu = (danach) => { merken(); setOffen(false); if (danach) danach(); };
  const btn = (primary) => ({
    flex: 1, minWidth: 120, padding: '12px', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer',
    border: primary ? 'none' : `1px solid ${dark ? '#444' : '#ddd'}`, background: primary ? '#1976d2' : 'transparent',
    color: primary ? '#fff' : (dark ? '#fff' : '#23272f'),
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 2800,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 14 }}>
      <div data-testid="whatsnew" style={{ background: dark ? '#23272f' : '#fff', color: dark ? '#fff' : '#23272f', borderRadius: 14,
        width: '100%', maxWidth: 440, maxHeight: '90vh', overflowY: 'auto', padding: 20, boxShadow: '0 10px 40px rgba(0,0,0,0.4)' }}>
        <strong style={{ fontSize: 19 }}>✨ {t('whatsnewPopup.title')}</strong>
        <div style={{ fontSize: 15, marginTop: 8, lineHeight: 1.5, fontWeight: 600 }}>{t('whatsnewPopup.intro')}</div>
        <ul style={{ margin: '12px 0 0', paddingLeft: 20, fontSize: 14, lineHeight: 1.6 }}>
          {['i1', 'i2', 'i3', 'i4', 'i5'].map((k) => <li key={k}>{t(`whatsnewPopup.${k}`)}</li>)}
        </ul>
        <div style={{ fontSize: 13, color: dark ? '#aaa' : '#666', marginTop: 12, lineHeight: 1.5 }}>{t('whatsnewPopup.hint')}</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 16 }}>
          <button type="button" data-testid="whatsnew-setup" style={btn(true)} onClick={() => zu(onOpenSetup)}>🧭 {t('whatsnewPopup.openSetup')}</button>
          <button type="button" data-testid="whatsnew-help" style={btn(false)} onClick={() => zu(onOpenHelp)}>💡 {t('whatsnewPopup.openHelp')}</button>
        </div>
        <button type="button" data-testid="whatsnew-close" style={{ ...btn(false), width: '100%', marginTop: 10, flex: 'none' }} onClick={() => zu()}>{t('whatsnewPopup.close')}</button>
      </div>
    </div>
  );
}
